/**
 * lib-flexible 在部分浏览器（尤其 Edge 桌面）首屏可能把 html font-size 算成 0，
 * 而项目样式经 postcss-pxtorem 转成 rem，会导致整页“空白不可见”。
 */
const MIN_REM = 32; // 对应约 320 设计宽
const MAX_REM = 54; // 与 flexible 540 上限一致

function readRem(): number {
  const raw = getComputedStyle(document.documentElement).fontSize || '0';
  return Number.parseFloat(raw) || 0;
}

export function ensureFlexibleRem(): void {
  const docEl = document.documentElement;
  const current = readRem();
  if (current >= MIN_REM && current <= MAX_REM * 1.5) return;

  const dpr = Number(docEl.getAttribute('data-dpr') || 1) || 1;
  let width = docEl.getBoundingClientRect().width || window.innerWidth || 375;
  if (!width || width < 1) width = 375;
  if (width / dpr > 540) width = 540 * dpr;

  const rem = Math.min(Math.max(width / 10, MIN_REM), MAX_REM);
  docEl.style.fontSize = `${rem}px`;
  (window as any).rem = rem;
}

export function bindFlexibleRemGuard(): void {
  ensureFlexibleRem();
  if ((window as any).__flexibleRemGuardBound) return;
  (window as any).__flexibleRemGuardBound = true;
  window.addEventListener('resize', ensureFlexibleRem);
  window.addEventListener('pageshow', ensureFlexibleRem);
  // Edge 偶发首帧宽度为 0，下一帧再纠正一次
  window.requestAnimationFrame(() => ensureFlexibleRem());
  window.setTimeout(ensureFlexibleRem, 0);
  window.setTimeout(ensureFlexibleRem, 50);
}
